/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import * as S from '../../styles';

export interface ITextInputProps {
  id: string;
  label?: string;
  value?: string;
  required?: boolean;
  placeholder?: string;
  labelColor?: string;
  errorText?: string;
  pattern?: string;
  errorText1?: string;
  onCompChange?(id: string, payload: any): void;
}

export const TextInput = ({
  id,
  label,
  value,
  errorText,
  required,
  placeholder,
  onCompChange,
  labelColor,
  errorText1,
  pattern,
}: ITextInputProps) => {
  const [textValue, setTextValue] = useState(value ?? '');
  const onChange = (id: string, e: any) => {
    setTextValue(e?.target?.value);
    onCompChange && onCompChange(id, e?.target?.value);
  };
  console.log('pat->', pattern);
  const _renderLabelIf = () => {
    if (label) {
      return (
        <S.FormLabel color={labelColor}>
          {label}
          {required && <sup style={{ color: 'red' }}>*</sup>}
        </S.FormLabel>
      );
    }
    return null;
  };

  const _renderErrorTextIf = () => {
    if (errorText || errorText1) {
      return (
        <S.FeedbackLabel type="invalid">
          {required && textValue ? errorText1 : errorText}
        </S.FeedbackLabel>
      );
    }
    return null;
  };

  return (
    <>
      <Form.Group id={id} className="formgroup">
        {_renderLabelIf()}
        <InputGroup>
          <Form.Control
            style={{ border: 'none' }}
            // className="formcontrol shadow-none"
            value={textValue}
            onChange={onChange.bind(null, id)}
            onError={(e) => console.log('9->', e)}
            required={required}
            pattern={pattern}
            type="text"
            placeholder={placeholder}
          />
          {_renderErrorTextIf()}
        </InputGroup>
      </Form.Group>
    </>
  );
};

TextInput.defaultProps = {
  required: false,
};
